import styled from 'styled-components'

import { baseColors } from '@fairhq/common'

export const SquareIconBackground = styled.div`
  background-color: ${baseColors.backgroundPrimaryAction};
  color: ${baseColors.contentInverseContent};
  border-radius: 4px;
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`
